import logo from './logo.svg';
import './App.css';
import { Pos } from './view/Pos';
import { Route, HashRouter, Routes, Navigate } from 'react-router-dom'
import { Print } from './view/Print';
import Login from "./view/Login";
import { useEffect, useState } from 'react';


function App() {
  const [posSession, setPosSession] = useState(() => {
    return JSON.parse(localStorage.getItem("pos_session"));
  });

  global.srv = "https://pos.javafootwear.id/"
  // global.srv = "http://localhost/"

  const PrivateRoute = ({ children }) => {
    const session = localStorage.getItem("pos_session");
    if (!session) {
      return <Navigate to="/login" replace />;
    }
    return children;
  };

  return (
    <div className="App">
      <HashRouter>
        <Routes>
          <Route
            path="/login"
            element={<Login />}
          />

          <Route
            path="/"
            element={<Navigate to="/login" replace />}
          />

          <Route
            path="/pos"
            element={
              <PrivateRoute>
                <Pos posSession={posSession} />
              </PrivateRoute>
            }
          />

          <Route
            path="/print"
            element={
              <PrivateRoute>
                <Print />
              </PrivateRoute>
            }
          />
        </Routes>
      </HashRouter>

    </div>
  );
}

export default App;
